import React from 'react';
import { CssRadio } from './vbCssComponents';

class VBRadio extends React.Component {
  handleClick = () => {
    // Call the 'onClick' function passed as a prop to the component
    // Pass the 'value' prop as an argument to the 'onClick' function
    this.props.onClick(this.props.value);
  }

  render() {
    return (
      <div className="w-100 d-flex">
        <CssRadio className='d-flex align-items-flex-start align-items-center mb-1'>
          <div
            className={this.props.checked ? 'radio me-2 checked' : 'radio me-2'}
            onClick={this.handleClick}
          ></div>
          {this.props.label}
        </CssRadio>
      </div>
    );
  }
}

export default VBRadio;